module.exports = __webpack_public_path__ + "img/screenoff.4843f9e9.webp";